{
  "@description": "This prod version",

  "appName": "Jerny",
  "appMode": "PROD",
  
  "targetMcpUrl" : "https://api.jerny.nl/mcp",

  "comingSoon": true,

  "@baseUrl_desc": "this is the api gateway url to krakend",
  "baseUrl": "https://api.jerny.nl",

  "@StreamUrl_desc": "this is signalr, port of JernyGateway",
  "streamUrl": "https://stream.jerny.nl",

  "poller": {
    "intervalMs": 30000,
    "maxAttempts": 1000
    }

}
